// extracted by mini-css-extract-plugin
module.exports = {"StatusInfoPanel":"StatusInfoPanel_StatusInfoPanel__2bcTf","col":"StatusInfoPanel_col__30n6a"};